import Dashboard from 'layouts/dashboard';
import Categories from 'layouts/categories';
import Pages from 'layouts/pages';
import EditPage from 'layouts/EditPage';
import AddUpdatePageSlider from 'layouts/AddUpdatePageSlider';
import Billing from 'layouts/billing';
import Profile from 'layouts/profile';

import SignIn from 'layouts/authentication/sign-in';
import SignUp from 'layouts/authentication/sign-up';

import Icon from '@mui/material/Icon';

import Products from 'layouts/products';
import CaseStudies from 'layouts/caseStudies';
import CaseStudyForm from 'layouts/caseStudies/CaseStudyForm';

import AddUpdateFeaturesToCategory from 'layouts/categories/Features';
import AssignFeaturesToProductNew from 'layouts/products/AssignFeaturesNew';

import DataImport from 'layouts/dataImport';

import Customers from 'layouts/Customers';
import CustomerDetails from 'layouts/Customers/customerDetails';
import CreateCustomer from 'layouts/Customers/createCustomer';

import PromoCodes from './layouts/promocodes';
import PromoCodeForm from 'layouts/promocodes/PromoCodeForm';

import Orders from 'layouts/orders';
import OrderDetailPage from 'layouts/orders/orderDetails';

import GlobalReminderSettings from 'layouts/reminderSettings';
import ManageUserReminderSettings from 'layouts/reminderSettings/userReminderSettings';

import EmailTemplates from 'layouts/emailTemplates';
import EmailBranding from 'layouts/emailBranding';
import InvoiceSettings from 'layouts/invoiceSettings';
import MissedPaymentSettings from 'layouts/missedPaymentSettings';
import OtherSettings from 'layouts/otherSettings';
import SubscriptionTypeTab from 'layouts/subscriptionTabs';
import DynamicFilters from 'layouts/dynamicFilters';
import EnvVariables from 'layouts/envVariables';

import AdminNotifications from 'layouts/adminNotifications';
import AccountManagement from 'layouts/accountManagement';

import ValuePackList from 'layouts/valuePack/ValuePackList';
import MultiStepValuePackForm from 'examples/ValuePack/MultiStepValuePackForm';
import ValuePackView from 'layouts/valuePack/ValuePackView';
import ValuePackTiers from 'layouts/valuePack/ValuePackTiers';
import EditValuePackTier from 'layouts/valuePack/EditValuePackTier';
import ErrorBoundary from 'examples/ValuePack/ErrorBoundary';
import ValuePackCommonSettings from 'examples/ValuePack/components/ValuePackCommonSettings';

import IndustryForm from 'examples/Industry/IndustryForm';

import TicketList from 'layouts/tickets';

import SubscriptionType from 'layouts/subscriptionType/SubscriptionType';
import SubscriptionTypeList from 'layouts/subscriptionType/SubscriptionTypeList';
import SubscriptionTypeView from 'layouts/subscriptionType/SubscriptionTypeView';

import Designs from 'layouts/design/Design';
import CategoryDesigns from 'layouts/design/CategoryDesigns';
import DesignOrders from 'layouts/design/DesignOrders';

import SectionTemplateList from 'layouts/sectionTemplates';
import SectionTemplateForm from 'layouts/sectionTemplates/TemplateForm';
import SectionLibrary from 'layouts/sectionLibrary';
import PageSectionBuilder from 'layouts/pages/PageSectionBuilder';
import PageVersions from 'layouts/pages/PageVersions';
import SectionContentEditor from 'layouts/sections';
import SectionTemplatePreview from 'layouts/sectionTemplates/SectionTemplatePreview';

import ContactInquiryList from 'layouts/contactInquiry';
import QuestionnaireSubmissions from 'layouts/questionnaireSubmissions';
import QuestionAnswers from 'layouts/questionAnswers/ServicePlanManager';
import NewsletterSubscribers from 'layouts/newsletter';

import LegalPages from 'layouts/legalPages';
import LegalPageForm from 'layouts/legalPages/LegalPageForm';

import UnderstandItBetterList from 'layouts/understandItBetter/UnderstandItBetterList';
import UnderstandItBetterCreate from 'layouts/understandItBetter/UnderstandItBetterCreate';
import UnderstandItBetterView from 'layouts/understandItBetter/UnderstandItBetterView';
import UnderstandItBetterEdit from 'layouts/understandItBetter/UnderstandItBetterEdit';

import ErrorLogs from 'layouts/errorLogs';
import ErrorLogDetails from 'layouts/errorLogs/ErrorLogDetails';

import ActivityLogs from 'layouts/activityLogs';
import ActivityLogDetails from 'layouts/activityLogs/ActivityLogDetails';

import Unauthorized from 'layouts/unauthorized';

/* -------------------------------------------------------------------------- */
/*                              Sidebar Groups                                */
/* -------------------------------------------------------------------------- */

const sidebarGroups = [
  /* ------------------------------------------------------------------------ */
  /* Dashboard                                                                */
  /* ------------------------------------------------------------------------ */

  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: '/dashboard',
    component: <Dashboard />,
    protected: true,
  },

  /* ------------------------------------------------------------------------ */
  /* Page Management                                                          */
  /* ------------------------------------------------------------------------ */

  {
    type: 'group',
    name: 'Page Management',
    key: 'page-management',
    icon: 'layers',
    children: [
      {
        name: 'Web Pages',
        key: 'pages',
        icon: 'web',
        route: '/pages',
      },
      {
        name: 'Legal Pages',
        key: 'legal-pages',
        icon: 'gavel',
        route: '/legal-pages',
      },
      {
        name: 'Section Templates',
        key: 'section-templates',
        icon: 'dashboard_customize',
        route: '/section-templates',
      },
    ],
  },

  /* ------------------------------------------------------------------------ */
  /* Email Management                                                         */
  /* ------------------------------------------------------------------------ */

  {
    type: 'group',
    name: 'Email Management',
    key: 'email-management',
    icon: 'mail',
    children: [
      {
        name: 'Email Templates',
        key: 'email-templates',
        icon: 'mail',
        route: '/email-templates',
      },
      {
        name: 'Reminder Settings',
        key: 'reminder-settings',
        icon: 'alarm',
        route: '/remindersettings',
      },
      {
        name: 'Admin Notifications',
        key: 'admin-notifications',
        icon: 'notifications_active',
        route: '/admin-notifications',
      },
    ],
  },

  /* ------------------------------------------------------------------------ */
  /* Shop Management                                                         */
  /* ------------------------------------------------------------------------ */

  {
    type: 'group',
    name: 'Shop Management',
    key: 'shop-management',
    icon: 'storefront',
    children: [
      {
        name: 'Categories',
        key: 'categories',
        icon: 'category',
        route: '/categories',
      },
      {
        name: 'Products',
        key: 'products',
        icon: 'inventory_2',
        route: '/products',
      },
      {
        name: 'Value Pack',
        key: 'valuepack',
        icon: 'local_offer',
        route: '/value-pack',
      },
      {
        name: 'Subscription Type',
        key: 'subscription-type',
        icon: 'subscriptions',
        route: '/admin/subscription-type',
      },
      {
        name: 'Understand It Better',
        key: 'understand-it-better',
        icon: 'lightbulb',
        route: '/admin/understand-it-better',
      },
      {
        name: 'Design',
        key: 'design',
        icon: 'palette',
        route: '/admin/designs',
      },
    ],
  },

  /* ------------------------------------------------------------------------ */
  /* Leads Management                                                         */
  /* ------------------------------------------------------------------------ */

  {
    type: 'group',
    name: 'Leads Management',
    key: 'leads-management',
    icon: 'leaderboard',
    children: [
      {
        name: 'Contact Inquiry',
        key: 'contact-inquiry',
        icon: 'contact_mail',
        route: '/admin/contact-inquiry',
      },
      {
        name: 'Newsletter',
        key: 'newsletter',
        icon: 'mark_email_read',
        route: '/admin/newsletter',
      },
    ],
  },

  /* ------------------------------------------------------------------------ */
  /* Order Management                                                         */
  /* ------------------------------------------------------------------------ */

  {
    type: 'collapse',
    name: 'Orders',
    key: 'orders',
    icon: <Icon fontSize="small">table_view</Icon>,
    route: '/orders',
    component: <Orders />,
    protected: true,
  },

  /* ------------------------------------------------------------------------ */
  /* Q&A Center                                                               */
  /* ------------------------------------------------------------------------ */

  {
    type: 'group',
    name: 'Q&A Center',
    key: 'qa-center',
    icon: 'quiz',
    children: [
      {
        name: 'Question & Answers',
        key: 'question-answers',
        icon: 'help_outline',
        route: '/QuestionAnswers',
      },
      {
        name: 'Submissions',
        key: 'questionnaire-submissions',
        icon: 'assignment_turned_in',
        route: '/questionnaire-submissions',
      },
    ],
  },

  /* ------------------------------------------------------------------------ */
  /* Other Admin Sections                                                     */
  /* ------------------------------------------------------------------------ */

  {
    type: 'collapse',
    name: 'Data Import',
    key: 'data-import',
    icon: <Icon fontSize="small">upload_file</Icon>,
    route: '/data-import',
    component: <DataImport />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Case Studies',
    key: 'case-studies',
    icon: <Icon fontSize="small">auto_stories</Icon>,
    route: '/case-studies',
    component: <CaseStudies />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Promo Codes',
    key: 'promocodes',
    icon: <Icon fontSize="small">confirmation_number</Icon>,
    route: '/promocodes',
    component: <PromoCodes />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Billing',
    key: 'billing',
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: '/billing',
    component: <Billing />,
    protected: true,
  },

  {
    type: 'group',
    name: 'Settings',
    key: 'settings',
    icon: 'settings',
    children: [
      {
        name: 'Invoice Settings',
        key: 'invoice-settings',
        icon: 'receipt',
        route: '/settings/invoice',
      },
      {
        name: 'Missed Payments',
        key: 'missed-payment-settings',
        icon: 'payments',
        route: '/settings/missed-payments',
      },
      {
        name: 'Other Settings',
        key: 'other-settings',
        icon: 'tune',
        route: '/settings/other',
      },
      {
        name: 'Subscription Type Tab',
        key: 'subscription-tabs',
        icon: 'tab',
        route: '/settings/subscription-tabs',
      },
      {
        name: 'Dynamic Filters',
        key: 'dynamic-filters',
        icon: 'filter_list',
        route: '/settings/filters',
      },
      {
        name: 'Environment Variables',
        key: 'env-variables',
        icon: 'vpn_key',
        route: '/settings/env-variables',
      },
      {
        name: 'Account Management',
        key: 'account-management',
        icon: 'manage_accounts',
        route: '/settings/accounts',
      },
    ],
  },

  {
    type: 'collapse',
    name: 'Customers',
    key: 'customers',
    icon: <Icon fontSize="small">people</Icon>,
    route: '/customers',
    component: <Customers />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Tickets',
    key: 'tickets',
    icon: <Icon fontSize="small">support_agent</Icon>,
    route: '/tickets',
    component: <TicketList />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Error Logs',
    key: 'error-logs',
    icon: <Icon fontSize="small">bug_report</Icon>,
    route: '/error-logs',
    component: <ErrorLogs />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Activity Logs',
    key: 'activity-logs',
    icon: <Icon fontSize="small">history</Icon>,
    route: '/activity-logs',
    component: <ActivityLogs />,
    protected: true,
  },

  {
    type: 'collapse',
    name: 'Sign In',
    key: 'sign-in',
    icon: <Icon fontSize="small">login</Icon>,
    route: '/authentication/sign-in',
    component: <SignIn />,
    protected: false,
  },
];

/* -------------------------------------------------------------------------- */
/*                             Application Routes                             */
/* -------------------------------------------------------------------------- */

const routes = [
  ...sidebarGroups,

  /* ======================================================================== */
  /* PAGE MANAGEMENT                                                          */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Pages',
    key: 'pages',
    route: '/pages',
    component: <Pages />,
    protected: true,
    collapse: [
      {
        name: 'List',
        route: '/pages',
        component: <Pages />,
        protected: true,
      },
      {
        name: 'Edit Page',
        route: '/pages/edit/:pageId',
        component: <EditPage />,
        protected: true,
      },
      {
        name: 'Add Slider',
        route: '/pages/edit/:pageId/slider',
        component: <AddUpdatePageSlider />,
        protected: true,
      },
      {
        name: 'Update Slider',
        route: '/pages/edit/:pageId/slider/:sliderId',
        component: <AddUpdatePageSlider />,
        protected: true,
      },
    ],
  },

  {
    type: 'route',
    name: 'Legal Pages',
    key: 'legal-pages',
    route: '/legal-pages',
    component: <LegalPages />,
    protected: true,
    collapse: [
      {
        name: 'All Legal Pages',
        route: '/legal-pages',
        component: <LegalPages />,
        protected: true,
      },
      {
        name: 'Add Legal Page',
        route: '/legal-pages/new',
        component: <LegalPageForm />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Legal Page',
        route: '/legal-pages/edit/:pageId',
        component: <LegalPageForm />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* TEMPLATE MANAGEMENT                                                      */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Section Templates',
    key: 'section-templates',
    route: '/section-templates',
    component: <SectionTemplateList />,
    protected: true,
    collapse: [
      {
        name: 'All Templates',
        route: '/section-templates',
        component: <SectionTemplateList />,
        protected: true,
      },
      {
        name: 'Create Template',
        route: '/section-templates/new',
        component: <SectionTemplateForm />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Template',
        route: '/section-templates/:id/edit',
        component: <SectionTemplateForm />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'Preview Template',
        route: '/:id/preview',
        component: <SectionTemplatePreview />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* HIDDEN PAGE/SECTION ROUTES                                               */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Page Sections Builder',
    key: 'page-sections-builder',
    route: '/pages/:pageId/sections',
    component: <PageSectionBuilder />,
    protected: true,
    hidden: true,
    action: 'update',
  },

  {
    type: 'route',
    name: 'Page Versions',
    key: 'page-versions',
    route: '/pages/:pageId/versions',
    component: <PageVersions />,
    protected: true,
    hidden: true,
  },

  {
    type: 'route',
    name: 'Section Content Editor',
    key: 'section-content-editor',
    route: '/sections/:sectionId',
    component: <SectionContentEditor />,
    protected: true,
    hidden: true,
    action: 'update',
  },

  /* ======================================================================== */
  /* CATEGORIES                                                               */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Categories',
    key: 'categories',
    route: '/categories',
    component: <Categories />,
    protected: true,
    collapse: [
      {
        name: 'Categories',
        route: '/categories',
        component: <Categories />,
        protected: true,
      },
      {
        name: 'Add Update Features',
        route: '/categories/features/:categoryId',
        component: <AddUpdateFeaturesToCategory />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* PRODUCTS                                                                 */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Products',
    key: 'products',
    route: '/products',
    component: <Products />,
    protected: true,
    collapse: [
      {
        name: 'Products',
        route: '/products',
        component: <Products />,
        protected: true,
      },
      {
        name: 'Add Update Features',
        route: '/products/package/:productId',
        component: <AssignFeaturesToProductNew />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* ORDERS                                                                   */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Orders',
    key: 'orders',
    route: '/orders',
    component: <Orders />,
    protected: true,
    collapse: [
      {
        name: 'Orders',
        route: '/orders',
        component: <Orders />,
        protected: true,
      },
      {
        name: 'Order Details',
        route: '/admin/orders/:orderId',
        component: <OrderDetailPage />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* CASE STUDIES                                                             */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Case Studies',
    key: 'case-studies',
    route: '/case-studies',
    component: <CaseStudies />,
    protected: true,
    collapse: [
      {
        name: 'All Case Studies',
        route: '/case-studies',
        component: <CaseStudies />,
        protected: true,
      },
      {
        name: 'Add Case Study',
        route: '/case-studies/new',
        component: <CaseStudyForm />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Case Study',
        route: '/case-studies/edit/:caseStudyId',
        component: <CaseStudyForm />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* VALUE PACK                                                               */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Value Pack',
    key: 'valuepack',
    route: '/value-pack',
    component: <ValuePackList />,
    protected: true,
    collapse: [
      {
        name: 'All Value Packs',
        route: '/value-pack',
        component: <ValuePackList />,
        protected: true,
      },
      {
        name: 'Common Settings',
        route: '/value-pack/common-settings',
        component: <ValuePackCommonSettings />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'Create New',
        route: '/value-pack/create',
        component: (
          <ErrorBoundary>
            <MultiStepValuePackForm />
          </ErrorBoundary>
        ),
        protected: true,
        action: 'create',
      },
      {
        name: 'View Details',
        route: '/value-pack/view/:id',
        component: <ValuePackView />,
        protected: true,
        hidden: true,
        action: 'read',
      },
      {
        name: 'Edit Value Pack',
        route: '/value-pack/edit/:id',
        component: <MultiStepValuePackForm />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'Manage Tiers',
        route: '/value-pack/:id/tiers',
        component: <ValuePackTiers />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'Create/Edit Tier Configuration',
        route: '/value-pack/:valuePackId/tiers/:mode?/:durationId?/:countryId?',
        component: <EditValuePackTier />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* PROMO CODES                                                              */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Promo Codes',
    key: 'promocodes',
    route: '/promocodes',
    component: <PromoCodes />,
    protected: true,
    collapse: [
      {
        name: 'All Promo Codes',
        route: '/promocodes',
        component: <PromoCodes />,
        protected: true,
      },
      {
        name: 'Create Promo Code',
        route: '/promocodes/create',
        component: <PromoCodeForm />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Promo Code',
        route: '/promocodes/edit/:id',
        component: <PromoCodeForm />,
        protected: true,
        hidden: true,
        action: 'update',
      },
    ],
  },

  /* ======================================================================== */
  /* CUSTOMERS                                                                */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Customers',
    key: 'customers',
    route: '/customers',
    component: <Customers />,
    protected: true,
    collapse: [
      {
        name: 'List',
        route: '/customers',
        component: <Customers />,
        protected: true,
      },
      {
        name: 'View Customer',
        route: '/customers/:customerId',
        component: <CustomerDetails />,
        protected: true,
        hidden: true,
      },
      {
        name: 'Create Customer',
        route: '/customers/create',
        component: <CreateCustomer />,
        protected: true,
        hidden: true,
        action: 'create',
      },
    ],
  },

  /* ======================================================================== */
  /* REMINDER SETTINGS                                                        */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Reminder Settings',
    key: 'reminder-settings',
    route: '/remindersettings',
    component: <GlobalReminderSettings />,
    protected: true,
    collapse: [
      {
        name: 'Reminder Settings',
        route: '/remindersettings',
        component: <GlobalReminderSettings />,
        protected: true,
      },
      {
        name: 'User Reminder Settings',
        route: '/admin/user-reminder-settings',
        component: <ManageUserReminderSettings />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* SETTINGS                                                                 */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Invoice Settings',
    key: 'invoice-settings',
    route: '/settings/invoice',
    component: <InvoiceSettings />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Missed Payment Settings',
    key: 'missed-payment-settings',
    route: '/settings/missed-payments',
    component: <MissedPaymentSettings />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Other Settings',
    key: 'other-settings',
    route: '/settings/other',
    component: <OtherSettings />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Subscription Type Tab',
    key: 'subscription-tabs',
    route: '/settings/subscription-tabs',
    component: <SubscriptionTypeTab />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Dynamic Filters',
    key: 'dynamic-filters',
    route: '/settings/filters',
    component: <DynamicFilters />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Environment Variables',
    key: 'env-variables',
    route: '/settings/env-variables',
    component: <EnvVariables />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Account Management',
    key: 'account-management',
    route: '/settings/accounts',
    component: <AccountManagement />,
    protected: true,
  },

  /* ======================================================================== */
  /* EMAIL TEMPLATES                                                          */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Email Templates',
    key: 'email-templates',
    route: '/email-templates',
    component: <EmailTemplates />,
    protected: true,
    collapse: [
      {
        name: 'Email Templates',
        route: '/email-templates',
        component: <EmailTemplates />,
        protected: true,
      },
      {
        name: 'Email Branding',
        route: '/email-branding',
        component: <EmailBranding />,
        protected: true,
      },
    ],
  },

  /* ======================================================================== */
  /* ADMIN NOTIFICATIONS                                                      */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Admin Notifications',
    key: 'admin-notifications',
    route: '/admin-notifications',
    component: <AdminNotifications />,
    protected: true,
  },

  /* ======================================================================== */
  /* INDUSTRIES                                                               */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Create Industry',
    key: 'create-industry',
    route: '/industries/create',
    component: <IndustryForm />,
    protected: true,
    hidden: true,
  },

  {
    type: 'route',
    name: 'Edit Industry',
    key: 'edit-industry',
    route: '/industries/edit/:id',
    component: <IndustryForm />,
    protected: true,
    hidden: true,
  },

  /* ======================================================================== */
  /* TICKETS                                                                  */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Tickets',
    key: 'tickets',
    route: '/tickets',
    component: <TicketList />,
    protected: true,
    collapse: [
      {
        name: 'Tickets',
        route: '/tickets',
        component: <TicketList />,
        protected: true,
      },
    ],
  },

  /* ======================================================================== */
  /* ERROR LOGS                                                               */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Error Logs',
    key: 'error-logs',
    route: '/error-logs',
    component: <ErrorLogs />,
    protected: true,
    collapse: [
      {
        name: 'Error Logs',
        route: '/error-logs',
        component: <ErrorLogs />,
        protected: true,
      },
      {
        name: 'Error Log Details',
        route: '/error-logs/:id',
        component: <ErrorLogDetails />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* ACTIVITY LOGS                                                            */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Activity Logs',
    key: 'activity-logs',
    route: '/activity-logs',
    component: <ActivityLogs />,
    protected: true,
    collapse: [
      {
        name: 'Activity Logs',
        route: '/activity-logs',
        component: <ActivityLogs />,
        protected: true,
      },
      {
        name: 'Activity Log Details',
        route: '/activity-logs/:id',
        component: <ActivityLogDetails />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* DESIGNS                                                                  */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Designs',
    key: 'design',
    route: '/admin/designs',
    component: <Designs />,
    protected: true,
    collapse: [
      {
        name: 'All Categories',
        route: '/admin/designs',
        component: <Designs />,
        protected: true,
      },
      {
        name: 'Category Designs',
        route: '/admin/designs/category/:categoryId',
        component: <CategoryDesigns />,
        protected: true,
        hidden: true,
      },
      {
        name: 'Design Orders',
        route: '/admin/design-orders',
        component: <DesignOrders />,
        protected: true,
        hidden: true,
      },
    ],
  },

  /* ======================================================================== */
  /* SUBSCRIPTION TYPE                                                        */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Subscription Type',
    key: 'subscription-type',
    route: '/admin/subscription-type',
    component: <SubscriptionTypeList />,
    protected: true,
    collapse: [
      {
        name: 'All Subscriptions',
        route: '/admin/subscription-type',
        component: <SubscriptionTypeList />,
        protected: true,
      },
      {
        name: 'Create New',
        route: '/admin/subscription-type/create',
        component: <SubscriptionType />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Subscription',
        route: '/admin/subscription-type/edit/:id',
        component: <SubscriptionType />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'View Details',
        route: '/admin/subscription-type/:id',
        component: <SubscriptionTypeView />,
        protected: true,
        hidden: true,
        action: 'read',
      },
    ],
  },

  /* ======================================================================== */
  /* UNDERSTAND IT BETTER                                                    */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Understand It Better',
    key: 'understand-it-better',
    route: '/admin/understand-it-better',
    component: <UnderstandItBetterList />,
    protected: true,
    collapse: [
      {
        name: 'All Sections',
        route: '/admin/understand-it-better',
        component: <UnderstandItBetterList />,
        protected: true,
      },
      {
        name: 'Create New',
        route: '/admin/understand-it-better/create',
        component: <UnderstandItBetterCreate />,
        protected: true,
        hidden: true,
        action: 'create',
      },
      {
        name: 'Edit Sections',
        route: '/admin/understand-it-better/edit/:entityType/:entityId',
        component: <UnderstandItBetterEdit />,
        protected: true,
        hidden: true,
        action: 'update',
      },
      {
        name: 'View Details',
        route: '/admin/understand-it-better/view/:entityType/:entityId',
        component: <UnderstandItBetterView />,
        protected: true,
        hidden: true,
        action: 'read',
      },
    ],
  },

  {
    type: 'route',
    name: 'Question & Answers',
    key: 'question-answers',
    route: '/QuestionAnswers',
    component: <QuestionAnswers />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Q&A Submissions',
    key: 'questionnaire-submissions',
    route: '/questionnaire-submissions',
    component: <QuestionnaireSubmissions />,
    protected: true,
  },

  /* ======================================================================== */
  /* LEADS ROUTES                                                             */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Contact Inquiry',
    key: 'contact-inquiry',
    route: '/admin/contact-inquiry',
    component: <ContactInquiryList />,
    protected: true,
  },

  {
    type: 'route',
    name: 'Newsletter',
    key: 'newsletter',
    route: '/admin/newsletter',
    component: <NewsletterSubscribers />,
    protected: true,
  },

  /* ======================================================================== */
  /* PROFILE                                                                  */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Profile',
    key: 'profile',
    route: '/profile',
    component: <Profile />,
    protected: true,
    hidden: true,
    collapse: [
      {
        name: 'Profile',
        route: '/profile',
        component: <Profile />,
        protected: true,
      },
    ],
  },

  /* ======================================================================== */
  /* AUTHENTICATION                                                           */
  /* ======================================================================== */

  {
    type: 'route',
    name: 'Sign In',
    key: 'sign-in',
    route: '/authentication/sign-in',
    component: <SignIn />,
    protected: false,
  },

  {
    type: 'route',
    name: 'Sign Up',
    key: 'sign-up',
    route: '/authentication/sign-up',
    component: <SignUp />,
    protected: false,
  },

  {
    type: 'route',
    name: 'Unauthorized',
    key: 'unauthorized',
    route: '/unauthorized',
    component: <Unauthorized />,
    protected: true,
  },
];

export default routes;
